import { EditableField } from '@/components/admin/ProfileField';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { SelectControl, inputClass } from './controls';
import { formatDate, formatCurrency, documentStatuses, depositStatuses, yesNoOptions } from './studentSectionHelpers';

const fields = {
  compliance: [
    ['International Student', 'is_international', 'boolean'],
    ['Study Permit Status', 'study_permit_status', documentStatuses],
    ['Study Permit Expiry', 'study_permit_expiry', 'date'],
    ['Compliance Verified At', 'compliance_verified_at', 'date'],
    ['Visa Status', 'visa_status', documentStatuses],
    ['Visa Expiry', 'visa_expiry', 'date'],
    ['Compliance Notes', 'compliance_notes', 'multiline'],
  ],
  loan: [
    ['Has Student Loan', 'has_student_loan', 'boolean'],
    ['Loan Total', 'loan_total', 'number'], ['Loan Paid', 'loan_paid', 'number'],
  ],
  deposit: [
    ['Deposit Required', 'deposit_required', 'boolean'],
    ['Deposit Status', 'deposit_status', depositStatuses],
    ['Deposit Amount', 'deposit_amount', 'number'],
    ['Deposit Due Date', 'deposit_due_date', 'date'],
    ['Deposit Paid Date', 'deposit_paid_date', 'date'],
    ['Deposit Notes', 'deposit_notes', 'multiline'],
  ],
};

export default function StudentDataFields({ section, record, form, editing, setText, setSelect }) {
  return <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
    {fields[section].map(([label, key, type]) => {
      const options = type === 'boolean' ? yesNoOptions : Array.isArray(type) ? type : null;
      const value = record[key];
      const display = type === 'date' ? formatDate(value)
        : type === 'number' ? formatCurrency(value)
          : type === 'boolean' ? (value ? 'Yes' : 'No')
            : options ? options.find((option) => option.value === value)?.label || value : value;
      return <EditableField key={key} label={label} display={display} editing={editing} full={type === 'multiline'}>
        {options ? <SelectControl value={form?.[key] || ''} options={options} onChange={setSelect(key)} />
          : type === 'multiline' ? <Textarea value={form?.[key] || ''} onChange={setText(key)} className={inputClass} />
            : <Input type={type} min={type === 'number' ? 0 : undefined} step={type === 'number' ? '0.01' : undefined} value={form?.[key] || ''} onChange={setText(key)} className={inputClass} />}
      </EditableField>;
    })}
  </div>;
}
